import { Checkbox, FormControlLabel, Grid, TextField } from "@mui/material"
import { Box } from "@mui/system"
import { FC } from "react"
import {useTranslation} from "react-i18next";

type Props = {
    error: string | undefined,
    section: string | undefined,
    isSection: boolean,
    handleSectionChange: (section: string | undefined) => void,
    handleIsSectionChange: (isSection: boolean) => void
}
export const EditSectionDetailsComponent: FC<Props> = ({ isSection, handleIsSectionChange, section, handleSectionChange, error }) => {
    const {t} = useTranslation()
    return (
        <>
            <Grid xs={6} item>
                <FormControlLabel labelPlacement="start" control={
                    <Checkbox checked={isSection} onChange={() => handleIsSectionChange(!isSection)} />
                } label={t('event.section')} />

            </Grid>
            {isSection && (
                <Grid xs={12} item justifyContent="center" justifyItems="center" alignItems="center">
                    <Box display="flex" justifyContent="center" >
                        <TextField
                            sx={{ width: 300 }}
                            error={!!error}
                            helperText={error}
                            label={t('event.dayAndHour')}
                            id="event-name"
                            value={section}
                            onChange={(e) => handleSectionChange(e.target.value)}
                        />
                    </Box>
                </Grid>
            )}
        </>
    )
}
